import React from 'react'

function Order() {
    return (

        <div style={{paddingTop : 200 , textAlign : 'center' , fontSize : 100 , color : "#EF5B2B"}}>Thank you for placing the order.</div>
    )
}

export default Order;